import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './constants.reducer';

export const ConstantsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const constantsEntity = useAppSelector(state => state.constants.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="constantsDetailsHeading">
          <Translate contentKey="reachamyApp.constants.detail.title">Constants</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{constantsEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="reachamyApp.constants.name">Name</Translate>
            </span>
          </dt>
          <dd>{constantsEntity.name}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="reachamyApp.constants.value">Value</Translate>
            </span>
          </dt>
          <dd>{constantsEntity.value}</dd>
        </dl>
        <Button tag={Link} to="/constants" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/constants/${constantsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConstantsDetail;
